import InvalidImage from './InvalidImage';
import ServerBusy from './ServerBusy';
import ServerError from './ServerError';
import { ERROR_KIND } from '../constants';

const SimulationError = ({ error, onRetry, onChooseAnother }) => {
    switch (error?.kind) {
        case ERROR_KIND.RESHOOT:
            return <InvalidImage onChooseAnother={onChooseAnother} />;

        case ERROR_KIND.BUSY:
            return <ServerBusy onRetry={onRetry} onChooseAnother={onChooseAnother} />;

        case ERROR_KIND.NOT_FOUND:
            return (
                <ServerError
                    message="The result image isn't on the server. Please run the simulation again."
                    onRetry={onRetry}
                    onChooseAnother={onChooseAnother}
                />
            );

        case ERROR_KIND.NO_RESULT:
            return (
                <ServerError
                    message="The simulation finished but the result image didn't come back."
                    onRetry={onRetry}
                    onChooseAnother={onChooseAnother}
                />
            );

        case ERROR_KIND.NO_CLINIC:
            return (
                <ServerError
                    message="Your clinic details are missing, so we couldn't file this simulation. Please sign out and back in."
                    onRetry={onRetry}
                    onChooseAnother={onChooseAnother}
                />
            );

        default:
            return (
                <ServerError
                    message="Something went wrong while running the simulation. Please try again in a moment."
                    onRetry={onRetry}
                    onChooseAnother={onChooseAnother}
                />
            );
    }
};

export default SimulationError;
